import { isHotkey, formatHotKeys, parseKeyboardShortcut } from './hotkeys.mjs';
import { GenericHotKey, MacHotKey, WindowsHotKey } from './keys.mjs';
export { KEYBOARD_SHORTCUT_COMBINATOR, KEYBOARD_SHORTCUT_COMBINATOR_REGEX } from './keys.mjs';

const HotkeyUtilities = {
  isHotkey,
  formatHotKeys,
  parseKeyboardShortcut,
  GenericHotKey,
  MacHotKey,
  WindowsHotKey
};

export { GenericHotKey, HotkeyUtilities, MacHotKey, WindowsHotKey, formatHotKeys, isHotkey, parseKeyboardShortcut };
